
import React            from 'react';

import { toClassStr }   from '_utils/UiHelper';


const Popover = ({ addClasses, activePlan, onSelectPlan, onClose, options, heading, renderOption }) => {

  /*
  ==================================================
   HOOKS 
  ==================================================
  */


  /*
  ==================================================
   EVENT HANDLERS
  ==================================================
  */


  /*
  ==================================================
   EVENT PUBLISHERS
  ==================================================
  */


  /*
  ==================================================
   EVENT TRIGGERS
  ==================================================
  */


  /*
  ==================================================
   LOCAL UTILS
  ==================================================
  */


  /*
  ==================================================
   SUB RENDERERS
  ==================================================
  */

  const optionsList = () => {
    return   (
      <ul className='popover'>
        <div className='header'>{heading || 'Choose an option'}</div>

        {Object.entries(options).map(([key, option]) => (
          <li 
            key={option.id}
            className={`option-item ${activePlan === option.id ? 'active' : ''}`}
            onClick={() => {
              onSelectPlan(option.id);
              if (onClose) onClose();
              if (option.redirectUrl) {
                window.open(option.redirectUrl, '_blank');
              }
            }}
          >
            {renderOption ? renderOption(option) : (
              <>
                <div className="option-content">
                  <div className="option-title">{option.title}</div>
                  <div className="option-description">{option.details}</div>
                </div>

                <div className="option-extras">
                  {option.flag && <div className="option-flag">{option.flag}</div>}
                  <div className="option-value">{option.price}</div>
                </div>
              </>
            )}
          </li>
        ))}
      </ul>
    );
  };

  /*
  ==================================================
   EXPORTED COMPONENT  
  ==================================================
  */

  const classes = toClassStr(['popover-container', addClasses]);

  return (
    <div className={classes}>
      {optionsList()}
    </div>
  )
};

export default Popover;

